
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { MachinesNeedleMappingEntity } from './entity/machine-needle-mapping.entity';
import { MachineNeedleMappingController } from './machine-needle-mapping.controller';
import { MachineNeedleMappingService } from './machine-needle-mapping.service';
import { MachinesNeedleMappingRepository } from './machine-needle-mapping.repo';
@Module({
  imports:[TypeOrmModule.forFeature([MachinesNeedleMappingEntity])],
  controllers: [MachineNeedleMappingController],
  providers: [MachineNeedleMappingService,MachinesNeedleMappingRepository]
})
export class MachineNeedleMappingModule {}



